import { storage } from "@/firebase";
import firebase from "firebase/app";

export async function fetchAllItemsURL(dir: string) {
  let downloadUrls: string[] = [];

  let ref = storage.ref().child(dir);

  return new Promise(async (resolve, reject) => {
    let res = await ref.listAll();
    for (const item of res.items) {
      let url = await item.getDownloadURL();
      downloadUrls.push(url);
    }
    resolve(downloadUrls);
  });
}

export async function fetchFileURLByName(path: string) {
  let downloadUrl: string;

  let ref = storage.ref().child(path);

  return new Promise(async (res, rej) => {
    downloadUrl = await ref.getDownloadURL();
    res(downloadUrl);
  });
}

export async function fetchAllItems(dir: string) {
  let items: { url: string; name: string }[] = [];

  let ref = storage.ref().child(dir);

  return new Promise(async (resolve, reject) => {
    let res = await ref.listAll();
    for (const item of res.items) {
      let url = await item.getDownloadURL();
      let name = item.name;
      items.push({ url: url, name: name });
    }
    resolve(items);
  });
}

export async function submitFiles(
  dir: string,
  blob: any,
  callback?: (snapshot: any) => void
) {
  let ref = storage.ref().child(dir);
  await ref.put(blob).on("state_changed", (snapshot: any) => {
    if (callback) callback(snapshot);
  });
}
